import { ReactNode, forwardRef } from 'react';

import { Logo } from './logo';

import classNames from 'classnames';

interface HeaderProps {
    className?: string;
    children?: ReactNode;
}

export const Header = forwardRef<HTMLDivElement, HeaderProps>(({ className, children }, ref) => (
    <div
        ref={ref}
        className={classNames('ui inverted top sidebar segment visible no-print', className)}
        id="navbar"
    >
        {children}
    </div>
));

export const EmptyHeader = () => (
    <Header>
        <Logo to="/" />
    </Header>
);
